/**
 * Generated runtime TestId mirror for frontend/src/pages/AutoAssignRuleRequestCreateWizard.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AutoAssignRuleRequestCreateWizardTestIds = {
  autoAssignRuleRequestCreateWizardPage: "auto-assign-rule-request-create-wizard-page",
  autoAssignRuleRequestStepContainer: "auto-assign-rule-request-step-container",
  btnFilterAdd: "btn-filter-add",
  btnFilterAll: "btn-filter-all",
  btnFilterRemove: "btn-filter-remove",
  btnFilterUnchanged: "btn-filter-unchanged",
  btnNextStep: "btn-next-step",
  btnPreviousStep: "btn-previous-step",
  btnRuleTypeAccessProfile: "btn-rule-type-access-profile",
  btnRuleTypeFunctionGroup: "btn-rule-type-function-group",
  btnRunTest: "btn-run-test",
  btnSubmit: "btn-submit",
  btnToggleHelp: "btn-toggle-help",
  btnViewTestResults: "btn-view-test-results",
  colAction: "col-action",
  colIdentity: "col-identity",
  colParty: "col-party",
  expressionEditor: "expression-editor",
  expressionInvalid: "expression-invalid",
  expressionValid: "expression-valid",
  functionGroupAssociationEditor: "function-group-association-editor",
  inputName: "input-name",
  profileAssociationEditor: "profile-association-editor",
  testResultsSuccess: "test-results-success",
  linkIdentityDetail: (item_identityId: string) => `link-identity-detail-${item_identityId}`,
  linkIdentityDetailPrefix: () => "link-identity-detail-" as TestIdPrefix,
  linkPartyDetail: (item_partyId: string) => `link-party-detail-${item_partyId}`,
  linkPartyDetailPrefix: () => "link-party-detail-" as TestIdPrefix
} as const;
